<template>
  <div data-component-group="threads-dialog" data-component="add-comment">
    <dialog-add
      :title="$t('add_comment')"
      icon="mode_comment"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-threads-add-comment
          :thread="activeThread"
          can-see-permissions
          :is-loading="isAddingComment"
          :on-cancel="onCancel"
          :on-submit="onAddComments"
          :on-reopen="onReopenComments"
          :on-deny="onDenyThreadsWithComments"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isAddingComment: false,
      };
    },
    computed: {
      activeThread() {
        return this.$store.getters['threads/activeItem'];
      },
      returnRoute() {
        const isArchived = this.$route.matched.some((r) => r.name === 'archived-threads');
        return isArchived ? 'archived-threads' : 'threads';
      },
    },
    created() {
      if (!this.activeThread?.id) {
        this.$store.dispatch('threads/getItem', { id: this.$route.params.id })
          .then((thread) => this.$store.dispatch('threads/setActiveItem', thread));
      }
    },
    methods: {
      onCancel() {
        this.$router.push({ name: this.returnRoute });
      },
      onAddComments(comment) {
        this.isAddingComment = true;

        return this.$store
          .dispatch('threads/commentThread', { id: this.activeThread.id, comment })
          .then((res) => {
            this.$router.push({ name: this.returnRoute, query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingComment = false;
          });
      },
      onReopenComments(comment) {
        this.isAddingComment = true;

        return this.$store
          .dispatch('threads/reopenThread', { id: this.activeThread.id, comment })
          .then((res) => {
            this.$router.push({ name: this.returnRoute, query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingComment = false;
          });
      },
      onDenyThreadsWithComments(comment) {
        this.isAddingComment = true;

        return this.$store
          .dispatch('threads/denyThread', { id: this.activeThread.id, comment })
          .then((res) => {
            this.$router.push({ name: this.returnRoute, query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingComment = false;
          });
      },
    },
  };
</script>
